
define('app/board/collections/chatMessageCollection',[
	'jquery',
	'underscore',
	'backbone',
	'app/board/models/chatMessageModel'
], function($, _, Backbone, ChatMessageModel){
	var ChatMessageCollection = Backbone.Collection.extend({
		model : ChatMessageModel,
		
		initialize: function(models, options) {
			
	    },
	});
	
	return ChatMessageCollection;  
});